import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SbpPayment, SbpPaymentMethod, SbpStatus } from '@/types.ts'
import { DefaultFiltersState } from '@/stores'
import { B2CState } from '@/@types/b2c.types.ts'

import { SetFilterValue } from '../shared.ts'

export interface SbpTableState extends DefaultFiltersState {
  operationState?: SbpStatus
  transferState?: B2CState | 'ALL'
  orderId?: SbpPayment['operationId']
  requestId?: string
  reference?: string
  // YYYY-MM-DD
  dateFrom?: string
  // YYYY-MM-DD
  dateTo?: string
  sbpType?: SbpPaymentMethod
}

const initialState: SbpTableState = {
  operationState: undefined,
  transferState: undefined,
  orderId: undefined,
  requestId: undefined,
  reference: undefined,
  dateFrom: undefined,
  dateTo: undefined,
  sbpType: 'C2B',
  page: 0,
  showCount: 10,
}

const sbpPaymentsSlice = createSlice({
  name: 'sbpPayments',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
    paramsForRequest: (state) => ({
      dateTo: state.dateTo,
      dateFrom: state.dateFrom,
      operationState: state.operationState,
      transferState: state.transferState,
      reference: state.reference,
      orderId: state.orderId,
      requestId: state.requestId,
      type: state.sbpType,
    }),
    dateRange: (state) => [state.dateFrom, state.dateTo],
    sbpType: (state) => state.sbpType,
    resettableStateFilters: (state, filters: (keyof SbpTableState)[]) => filters.map((e) => state[e]),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<SbpTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof SbpTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const {
  reducer: sbpPaymentsReducer,
  selectors: sbpPaymentSelectors,
  actions: sbpPaymentsActions,
} = sbpPaymentsSlice
